module.exports = __webpack_public_path__ + "img/281.07d7b502.png";